/* global isNumber */

import FormatGeoJSON from '../node_modules/ol/format/GeoJSON.js';
// See otherMapViews.js for KML options which includes saving styles.
// import {fromCircle} from '../node_modules/ol/geom/Polygon.js';

/**
 * @typedef {function(string, ol.Feature | [ol.Feature])}
 * @param {string} mode 'new' | 'update'
 * @param {ol.Feature | [ol.Feature]} feature
 * @return nothing
 * called from:
 *   Draw.js:        'update' or 'new'
 *   ModifyVectorFeature.js:  'update'
 *   FeatureStyleControls.js: 'delete'
 */

export default function (mode, feature) {
  let formatGeoJSON = new FormatGeoJSON();
  let payload;

  function prepareFeature(feature) {
    let JSONFeature = feature.getProperties();
    // GeoJSON does not support circles so covert circle to a poly - doing this in Draw.js now
    // let geom = feature.getGeometry().getType() === 'Circle' ? fromCircle(feature.getGeometry()) : feature.getGeometry();

    // overwrite the geometry property with a GeoJSON version of the geom
    JSONFeature.geometry = formatGeoJSON.writeGeometryObject(feature.getGeometry(), {decimals: 1});

    delete JSONFeature.tooltipOverlay_;
    delete JSONFeature.hasGeomChangeHandler_;
    delete JSONFeature.revision0__;
    delete JSONFeature.hasOwnStyle_;

    let style = feature.getStyle();
    if (style && feature.get('hasOwnStyle_')) {
      style = style[0];
      JSONFeature.style_ = JSON.stringify({
        fill: style.getFill(),
        stroke: style.getStroke(),
        text: style.getText()
      }).replace(/_"/g, '"');  // remove all trailing underscores
    }
    return JSONFeature;
  }

  if (mode === 'update') {  // write multiple features in one ajax call
    payload = {
      action: 'update',
      features: []
    };
    let features = Array.isArray(feature) ? feature : [feature];
    features.forEach(f => {
      payload.features.push(prepareFeature(f));
    });

  } else {  // mode: 'new' or 'delete'
    // formatGeoJSON.writeFeatureObject(feature)
    // this maintains my original format
    // and discontinues the use of rwg.layers.getLayerByName('wfs').attributes.forEach()
    payload = prepareFeature(feature);
    payload.action = mode;
  }

  fetch('crud.php', {
    method: 'POST',
    contentType: 'application/json',
    body: JSON.stringify(payload),
  })
  .then(response => {
    if (!response.ok) {
      throw Error(response.status); //statusText
    } else {
      return response.json();
    }
  }) // skips to .catch if error is thrown
  .then(dat => {
    if (rwg.config.crudCallback) {
      rwg.config.crudCallback({
        mode: mode,
        feature: feature,
        payload: payload,
        result: dat,
      })
    }
    if (mode === 'new') {
      feature.set('ogc_fid', parseInt(dat))
    }
  })
  .catch(status => {
    console.error ('Error: ', status)
    alert('Error: ' + status )
  }) // catches the error and logs it

}
